import React, { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppButton = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() =>
        window.open(
          "https://chat.whatsapp.com/J6U0dVOafc68JxFdFvfGNA",
          "_blank"
        )
      }
      style={{
        position: "fixed",
        bottom: 20,
        right: 20,
        height: 60,
        width: isHovered ? 320 : 60,
        minWidth: 60,
        backgroundColor: "#c16d18",
        borderRadius: isHovered ? 40 : "50%",
        border: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        padding: isHovered ? "0 26px" : 0,
        overflow: "hidden",
        cursor: "pointer",
        boxShadow: "0 6px 18px rgba(0,0,0,0.3)",
        transition: "all 0.3s ease",
        zIndex: 9999,
      }}
    >
      {/* ✅ ICON (ALWAYS VISIBLE) */}
      <FaWhatsapp size={32} color="#fff" />

      {/* ✅ TEXT (REMOVED FROM LAYOUT WHEN HIDDEN) */}
      {isHovered && (
        <span
          style={{
            color: "#fff",
            fontSize: "1rem",
            fontWeight: 600,
            whiteSpace: "nowrap",
          }}
        >
          Join 10,000+ Auditors
        </span>
      )}
    </button>
  );
};

export default WhatsAppButton;
